<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { fade } from 'svelte/transition';

  export let title: string;
  export let subtitle: string;
  export let ctaLabel: string;

  const dispatch = createEventDispatcher<{ retry: void }>();

  function handleRetry() {
    dispatch('retry');
  }
</script>

<div
  class="connection-error-banner"
  transition:fade={{ delay: 300, duration: 300 }}
>
  <div class="banner-content">
    <div class="error-text">
      <span class="error-title">{title}</span>
      <span class="error-subtitle">{subtitle}</span>
    </div>
    <button on:click={handleRetry}>{ctaLabel}</button>
  </div>
</div>

<style lang="postcss">
  .connection-error-banner {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    padding: 1rem;
    box-sizing: border-box;
    pointer-events: auto;
  }

  .banner-content {
    background-color: rgba(0, 0, 0, 0.95);
    color: #ef4444; /* danger color */
    font-size: 0.9rem;
    padding: 0.75rem 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-radius: 6px;
    max-width: 90%;
    @media (min-width: 1024px) {
      max-width: 330px;
    }
    margin: auto;
  }

  .error-text {
    display: flex;
    flex-direction: column;
    gap: 0.25rem; /* Reduced gap */
  }

  .error-title {
    font-weight: 600;
  }

  .error-subtitle {
    font-weight: 400;
  }

  .connection-error-banner button {
    background-color: transparent;
    border: 1px solid #ef4444;
    color: #ef4444;
    padding: 0.4rem 0.8rem;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.85rem;
    font-weight: 500;
    transition: background-color 0.2s, color 0.2s;
    flex-shrink: 0; /* Prevent button from shrinking */
    margin-left: 1rem;
  }

  .connection-error-banner button:hover {
    background-color: #ef4444;
    color: white;
  }
</style> 